import styled from 'styled-components';
import Autocomplete from 'react-google-autocomplete';

import { inputBaseCss } from 'components/input/styles';

export const Input = styled(Autocomplete)<{ error?: string }>`
  ${inputBaseCss};
` as typeof Autocomplete;
